import React from 'react'
import { Button } from '@mui/material'
import GoogleIcon from '../../../icon/GoogleIcon'
import {
  EXPORT_BUTTON_DISABLED_ICON_COLOR,
  EXPORT_BUTTON_ICON_COLOR
} from '../style/metricsIndexStyles'

const ExportSingleButton = ({
  label = 'Descargar',
  disabled = false,
  onClick,
  ...props
}) => (
  <Button
    className="download-doble-reports download-doble-reports-single-full"
    disabled={disabled}
    onClick={onClick}
    startIcon={
      <GoogleIcon
        name="download_2"
        size={16}
        filled
        color={disabled ? EXPORT_BUTTON_DISABLED_ICON_COLOR : EXPORT_BUTTON_ICON_COLOR}
      />
    }
    {...props}
  >
    {label}
  </Button>
)

export default ExportSingleButton
